import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRolesService } from '@bp-core/src/lib/services/portal/user-roles.service';
import { SudoAccessStore } from 'bp/shared/services/sudo-access.store';
import { isSudoAccessDeferred, landingUrl } from './sudo-access.guard';

/**
 * Acceso a Comunicaciones › Notificaciones Usuarios (feature 055, R-12): `admin`, `sudo` (como hoy)
 * o `customer-success`.
 *
 * Reemplaza al `AuthGuard` en esta ruta: el `AuthGuard` manda al usuario solo CS a esta misma
 * página, así que usarlo aquí crearía un bucle de redirecciones (H-9). Quien no tiene acceso aterriza en
 * su inicio (`homeFor`) o, si no tiene acceso al sudo, en `/errors/401`.
 *
 * En una carga directa, mientras los permisos del sudo no llegan, cede el paso: el layout revalida la
 * URL con los permisos y lleva a la persona a su inicio (feature 057, H4).
 */
export const userNotificationsGuard: CanActivateFn = () => {
  const roles = inject(UserRolesService);
  const router = inject(Router);
  const store = inject(SudoAccessStore);

  roles.loadRolesFromToken();

  if (roles.isAdmin() || roles.isSudo() || roles.isCustomerSuccess() || isSudoAccessDeferred()) {
    return true;
  }

  return router.createUrlTree([landingUrl(store)]);
};
